"use client"

import { catchError, type ErrorInfo } from "next/error"
import type { ReactNode } from "react"

interface Props {
    fallback?: ReactNode
}

function ErrorBoundaryFallback({ fallback }: Props, { retry }: ErrorInfo) {
    if (fallback) {
        return fallback
    }

    return (
        <div className="flex min-h-[400px] items-center justify-center p-8">
            <div className="text-center">
                <p className="mb-4 font-medium text-foreground text-lg">
                    Something went wrong
                </p>
                <p className="text-muted-foreground text-sm">
                    You can retry loading this section
                </p>
                <button
                    type="button"
                    onClick={() => retry()}
                    className="mt-6 border border-border/70 bg-transparent px-6 py-3 font-mono text-foreground text-xs uppercase tracking-widest transition-all hover:border-foreground dark:border-border/40"
                >
                    Try Again
                </button>
            </div>
        </div>
    )
}

export const ErrorBoundary = catchError(ErrorBoundaryFallback)
